import React from 'react';
import { AuthProvider } from './context/AuthProvider'
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Login from './pages/Login';
import Welcome from './pages/Welcome';
import Accounts from './pages/Accounts';
import NewAccount from './pages/NewAccount';
import Logs from './pages/Logs';
import Roles from './pages/Roles';
import NewRole from './pages/NewRole';
import Cashiers from './pages/Cashiers';
import Header from './components/Header';
import Footer from './components/Footer';
import NewCasher from './pages/NewCashier';
import DrawerCashier from './pages/DrawerCashier';
import RouteProvider from './context/RouteProvider';
import Devices from './pages/Devices';
import NewDevice from './pages/NewDevice';
import DeviceVersions from './pages/DeviceVersions';
import NewDeviceVersion from './pages/NewDeviceVersion';
import Distributors from './pages/Distributors';
import NewDistributorServer from './pages/NewDistributorServer';
import NewDistributor from './pages/NewDistributor'
import Charities from './pages/Charities';
import NewCharity from './pages/NewCharity';
import Locations from './pages/Locations';
import NewLocation from './pages/NewLocation';
import { LoadingProvider } from './context/LoadingProvider';
import Loading from './components/UI/Loading';
import AdvancedBreadcrumb from './components/AdvancedBreadcrumb';
import PulltabGames from './pages/PulltabGames';
import UploadGame from './pages/UploadGame';
import GameSettings from './pages/GameSettings';
import DecksManagement from './pages/DecksManagement';
import PulltabDecks from './pages/PulltabDecks';
import BingoConfiguration from './pages/BingoConfiguration';
import LobbyOrder from './pages/LobbyOrder';
import BingoGames from './pages/BingoGames';
import BingoDefinitions from './pages/BingoDefinitions';
import GeneratorQueueStatus from './pages/GeneratorQueueStatus';
import DrawerManagement from './pages/DrawerManagement';
import PosBundleServerManagement from './pages/PosBundleServerManagement'
import DeckStatus from './pages/DeckStatus';
import Jackpots from './pages/Jackpots';
import NewJackpot from './pages/NewJackpot';
import ProviderWrapper from './components/ProviderWrapper';
import Reports from './pages/Reports';
import Config from './pages/Config';
import LocationTopology from './pages/LocationTopology';
import MigrationQueue from './pages/MigrationQueue';
import MigrationStatus from './pages/MigrationStatus';
import JackpotHistory from './pages/JackpotHistory';
import JackpotPayments from './pages/JackpotPayments';
import EditJackpotPayment from './pages/EditJackpotPayment';
import endpoints from './utils/endpoints';
import {baseURL} from "./services/api";
import DistributorServers from './pages/DistributorServers';
import BundleManagement from "./pages/BundleManagement";
import LobbyTab from "./pages/LobbyTab";
import SeasonalManagement from "./pages/SeasonalManagement";
import Messaging from "./pages/Messaging";
import DeviceBulkEdit from "./pages/DeviceBulkEdit";

function App() {

  return (
    <AuthProvider>
      <Router>
        <Header />
        <ProviderWrapper>
          <>
            <Loading />
            <AdvancedBreadcrumb />
            <Routes>
              {/*Login page */}
              <Route path="/" element={<Login />} />
              <Route path="/:param" element={<Login />} />

              {/*Welcome page*/}
              <Route path="/welcome/" element={<Welcome />} />

              {/*Accounts pages*/}
              <Route path="/users" element={<Accounts accessLevel='users' />} />
              <Route path="/users/new" element={<NewAccount />} />
              <Route path="/users/new/:id" element={<NewAccount />} />

              {/*logs page*/}
              <Route path="/logs" element={<Logs />} />

              {/*Roles pages*/}
              <Route path="/roles" element={<Roles accessLevel='users' />} />
              <Route path="/roles/new" element={<NewRole />} />
              <Route path="/roles/new/:id" element={<NewRole />} />

              {/*Cashiers pages*/}
              <Route path="/cashiers" element={<Cashiers accessLevel='cashiers' />} />
              <Route path="/cashiers/new" element={<NewCasher />} />
              <Route path="/cashiers/new/:id" element={<NewCasher />} />
              <Route path="/drawercashiers" element={<DrawerCashier accessLevel='cashiers' />} />

              {/*Devices pages*/}
              <Route path="/devices/list" element={<Devices accessLevel='devices' />} />
              <Route path="/devices/new" element={<NewDevice />} />
              <Route path="/devices/new/:id" element={<NewDevice />} />
              <Route path="deviceversions/list" element={<DeviceVersions accessLevel='device_versions' />} />
              <Route path="deviceversions/new" element={<NewDeviceVersion />} />
              <Route path="deviceversions/new/:id" element={<NewDeviceVersion />} />
              <Route path="/devices/bulkedit" element={<DeviceBulkEdit accessLevel='devices' />} />

              {/*Distributors*/}
              <Route path="/distributors" element={<Distributors accessLevel='distributors' />} />
              <Route path="/distributors/new" element={<NewDistributor />} />
              <Route path="/distributors/new/:id" element={<NewDistributor />} />
              <Route path="/distributorservers/:name/:id" element={<DistributorServers />} />

              {/*Servers */}
              <Route path="/distributorserver/new/:distributor" element={<NewDistributorServer accessLevel='distributors' />} />
              <Route path="/distributorserver/new/:distributor/:id" element={<NewDistributorServer accessLevel='distributors' />} />

              {/*Charities*/}
              <Route path="/charities" element={<Charities accessLevel='charities' />} />
              <Route path="/charities/new" element={<NewCharity />} />
              <Route path="/charities/new/:id" element={<NewCharity />} />

              {/*Locations*/}
              <Route path="/locations" element={<Locations accessLevel='locations' />} />
              <Route path="/locations/new" element={<NewLocation />} />
              <Route path="/locations/new/:id" element={<NewLocation />} />

              {/*Pull-Tab Games*/}
              <Route path="/games/list" element={<PulltabGames accessLevel='games' />} />
              <Route path="/games/upload" element={<UploadGame accessLevel='games' type="game"/>} />
              <Route path="/games/settings/:id" element={<GameSettings accessLevel='games' />} />
              <Route path="/bundlemanagement" element={<BundleManagement accessLevel='bundle_management'/>} />

              {/*Decks Management*/}
              <Route path="/decksmanagement" element={<DecksManagement accessLevel='games' />} />

              {/*Pulltab Games*/}
              <Route path="/boxes/list" element={<PulltabDecks accessLevel='boxes' />} />

              {/*Pulltab Games*/}
              <Route path="/bingoconfig" element={<BingoConfiguration accessLevel='bingo_config' />} />

              {/*Lobby Order*/}
              <Route path="/gameorderings" element={<LobbyOrder accessLevel='game_orderings' />} />

              {/*Lobby Tabs*/}
              <Route path="/lobbytabs" element={<LobbyTab accessLevel='lobby_tabs' />} />

              {/*Bingo Games*/}
              <Route path="/bingogames" element={<BingoGames accessLevel='bingo_games' />} />

              {/*Bingo Definitions*/}
              <Route path="/bingogamelist" element={<BingoDefinitions accessLevel='' />} />
              <Route path="/bingogamelist/upload" element={<UploadGame accessLevel='games' type="bingo" />} />

              {/*Generator queue status*/}
              <Route path="/queuestatus" element={<GeneratorQueueStatus />} />

              <Route path="/drawermanagement" element={<DrawerManagement />} />

              <Route path="/seasonalmanagement" element={<SeasonalManagement />} />

              <Route path="/posbundleservermanagement" element={<PosBundleServerManagement />} />

              <Route path="/decksstatus/list" element={<DeckStatus />} />

              <Route path="/jackpots/list" element={<Jackpots />} />

              <Route path="/jackpots/new" element={<NewJackpot />} />

              <Route path="/jackpots/new/:id" element={<NewJackpot />} />

              <Route path="/jackpotshistory/list" element={<JackpotHistory />} />

              <Route path="/jackpotspayrolls/list" element={<JackpotPayments />} />

              <Route path="/jackpotspayrolls/edit/:type/:id" element={<EditJackpotPayment />} />

              <Route path="/migrationqueue" element={<MigrationQueue />} />
              
              <Route path="/migrationstatus" element={<MigrationStatus />} />

              <Route path="/locationtopology" element={<LocationTopology />} />

              <Route path="/manufacturerconfig" element={<Config />} />

              <Route path="/messaging" element={<Messaging />} />

              <Route path="/reports" element={<Reports />} />

            </Routes>
          </>
        </ProviderWrapper>
        <Footer />
        <div id="urlInfo" data-base-url={baseURL} style={{display: "none"}}>{baseURL}</div>
      </Router>
    </AuthProvider>
  )
}

export default App
